export default "__VITE_ASSET__BXWOI_xY__"